import { Injectable } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFirestore} from '@angular/fire/firestore';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {AlertService} from './alert.service';

export interface UserData {
  name?: string;
  chessComName?: string;
  email?: string;
  coin?: number;
}

export interface ChessComUserData {
  avatar?: string;
  status?: string;
  username?: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private eventAuthError = new BehaviorSubject<string>("");
  eventAuthError$ = this.eventAuthError.asObservable();

  newUser: any;
  users: Observable<UserData[]>

  constructor(
    private afAuth: AngularFireAuth,
    private db: AngularFirestore,
    private router: Router,
    private alert: AlertService
  ) {
    this.users = this.db.collection('Users').valueChanges()
  }

  getUsers() {
    return this.users;
  }

  getUserState() {
    return this.afAuth.authState;
  }

  login(email: string, password: string) {
    this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .catch(error => {
        switch (error.code) {
          case 'auth/user-not-found':
            // @ts-ignore
            this.eventAuthError.next(this.alert.warning('Пользователь не найден'))
            break
          case 'auth/wrong-password':
            // @ts-ignore
            this.eventAuthError.next(this.alert.warning('Неверный пароль'))
            break;
        }
      })
      .then(userCredential => {
        if (userCredential) {
      this.router.navigate(['/dashboard/main']);
      this.alert.success('Вы авторизовались');
        }
      });
  }

  createUser(user) {
    this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.password)
      .then(userCredential => {
        this.newUser = user;
        userCredential.user.updateProfile({
          displayName: user.name
        });
        this.insertUserData(userCredential)
          .then(() => {
            this.router.navigate(['/dashboard/main']);
          });
      })
      .catch(error => {
        switch (error.code) {
          case 'auth/email-already-in-use':
            this.eventAuthError.next('Пользователь с таким email уже существует')
            break;
        }
    });
  }

  insertUserData(userCredential: firebase.auth.UserCredential) {
    return this.db.doc(`Users/${userCredential.user.uid}`).set({
      email: this.newUser.email,
      name: this.newUser.name,
      chessComName: this.newUser.chessComName,
      coin: this.newUser.coin
    });
  }

  logout() {
    return this.afAuth.auth.signOut();
  }
}
